import { isNotificationPermission } from '../../utils/helpers';

import { onMessageListener } from './firebase';

export interface IPayloadMessageListener {
  notification: {
    title: string;
    body: string;
    image: string;
    icon: string;
    url: string;
  };
}

const useFirebase = () => {
  isNotificationPermission &&
    onMessageListener()
      .then((payload: IPayloadMessageListener | any) => {
        navigator.serviceWorker
          .getRegistrations()
          .then((registrations) => {
            registrations
              .find((registrationItem: ServiceWorkerRegistration) =>
                registrationItem.active?.scriptURL.includes(
                  process.env.NODE_ENV === 'production'
                    ? 'firebase-messaging-sw-production.js'
                    : 'firebase-messaging-sw-development.js',
                ),
              )
              ?.showNotification(payload?.notification?.title || '', {
                ...payload?.notification,
                data: {
                  url_for_ground: payload?.fcmOptions?.link || '',
                },
              });
          })
          .catch((e) => {
            console.log(e, 'errorGetRegistrations');
          });
      })
      .catch((e) => {
        console.log(e, 'errorOnMessageListener');
      });
};

export default useFirebase;
